export interface SessionTimeRemaining {
  days: number;
  hours: number;
  milliseconds: number;
  minutes: number;
  seconds: number;
}

export interface InteractiveSession extends EventTarget {
  isInitialized: boolean;
  begin(accessToken: string): Promise<SessionTimeRemaining | null>;
  extend(): Promise<SessionTimeRemaining | null>;
  remaining(): Promise<SessionTimeRemaining | null>;
  end(): Promise<void>;
  validate(): Promise<boolean>;
  remainingTime: SessionTimeRemaining | null;
}

export enum SessionEndReason {
  expired = 0,
  different_user = 1,
  logout = 2,
  logout_elsewhere = 3,
  no_substitutes = 4
}

export class SessionEnding extends Event {
  public readonly reason: SessionEndReason;
  constructor(reason: SessionEndReason = SessionEndReason.expired) {
    super('ending');
    this.reason = reason;
  }
}

export class SessionEnded extends Event {
  public readonly reason: SessionEndReason;
  constructor(reason: SessionEndReason = SessionEndReason.expired) {
    super('ended');
    this.reason = reason;
  }
}

export class SessionUpdated extends Event {
  public readonly remainingTime: SessionTimeRemaining | null;

  constructor(remainingTime: SessionTimeRemaining | null) {
    super('updated');
    this.remainingTime = remainingTime;
  }
}

export class SessionStarted extends Event {
  public readonly actualUser?: string;
  public readonly remainingTime: SessionTimeRemaining | null;
  constructor(actualUser: string, remainingTime: SessionTimeRemaining | null) {
    super('started');
    this.remainingTime = remainingTime;
    this.actualUser = actualUser;
  }
}
